/**
 * NDL Blog
 * Swiper for mobile blog cards and optional desktop overflow carousel.
 */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 999px)';
  var mediaQuery = window.matchMedia(MOBILE_QUERY);

  function initSection(section) {
    if (!section) return;

    if (section.dataset.ndlBlogReady === 'true') {
      if (section.ndlBlogController && typeof section.ndlBlogController.sync === 'function') {
        section.ndlBlogController.sync();
      }
      return;
    }

    var swiperEl = section.querySelector('.ndl_blog__swiper');
    if (!swiperEl || typeof window.Swiper === 'undefined') return;

    var swiper = null;
    var activeMode = null;

    function destroySwiper() {
      if (!swiper) return;

      swiper.destroy(true, true);
      swiper = null;
      activeMode = null;
    }

    function createSwiper(mode) {
      var isMobile = mode === 'mobile';
      var params = {
        spaceBetween: 12,
        grabCursor: true,
        watchOverflow: true,
        pagination: {
          el: section.querySelector('.ndl_blog__pagination'),
          clickable: true
        }
      };

      if (isMobile) {
        params.slidesPerView = 1.2;
        params.breakpoints = {
          480: {
            slidesPerView: 2,
            spaceBetween: 12
          }
        };
      } else {
        params.slidesPerView = Number(section.dataset.desktopSlidesPerView) || 3;
        params.navigation = {
          prevEl: section.querySelector('.ndl_blog__arrow--prev'),
          nextEl: section.querySelector('.ndl_blog__arrow--next')
        };
      }

      swiper = new window.Swiper(swiperEl, params);
      activeMode = mode;
    }

    function sync() {
      var desiredMode = null;
      var mobileLayout = section.dataset.mobileLayout || 'stacked';
      var desktopCarousel = section.dataset.desktopCarousel === 'true';

      if (mediaQuery.matches && mobileLayout === 'slider') {
        desiredMode = 'mobile';
      } else if (!mediaQuery.matches && desktopCarousel) {
        desiredMode = 'desktop';
      }

      if (!desiredMode) {
        destroySwiper();
        return;
      }

      if (activeMode === desiredMode) {
        if (swiper) swiper.update();
        return;
      }

      destroySwiper();
      createSwiper(desiredMode);
    }

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', sync);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(sync);
    }

    section.ndlBlogController = {
      sync: sync,
      destroy: destroySwiper
    };
    section.dataset.ndlBlogReady = 'true';
    sync();
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-ndl-blog]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
